import _ from "lodash";
import { securedAxios } from "../lib/axios";
const contatoModelo = {
  nome: "",
  observacoes: "",
  tipos: [],
  telefones: [],
  emails: [],
};

const emailModelo = {
  nome: "",
  descricao: "",
  email: "",
  principal: false,
};

const telefoneModelo = {
  nome: "",
  descricao: "",
  numero: "",
  celular: false,
  whatsapp: false,
  telegram: false,
  principal: false,
};

const ajustaContato = (contato) => {
  if (contato.novo) {
    delete contato.id;
  }
  contato.telefones = contato.telefones.map((t) => {
    if (t.novo) {
      delete t.id;
    }
    return t;
  });
  contato.emails = contato.emails.map((e) => {
    if (e.novo) {
      delete e.id;
    }
    return e;
  });
  return contato;
};

export default {
  namespaced: true,
  state: {
    paramsLista: null,
    tiposContato: [
      {
        text: "Comercial",
        value: "comercial",
      },
      {
        text: "Financeiro",
        value: "financeiro",
      },
      {
        text: "Administrativo",
        value: "administrativo",
      },
      {
        text: "Diretoria",
        value: "diretoria",
      },
      {
        text: "Técnico",
        value: "tecnico",
      },
      {
        text: "Receita",
        value: "receita",
      },
      {
        text: "Outro",
        value: "outro",
      },
    ],
    contatoAtivo: null,
    emailAtivo: null,
    telefoneAtivo: null,
  },
  getters: {
    strTipo: (state) => (tipo) =>
      state.tiposContato.find((t) => t.value === tipo).text,
    principal: () => (lista) => lista.find((i) => i.principal) || lista[0],
  },
  mutations: {
    setParamsLista(state, params) {
      state.paramsLista = params;
    },
    setContatoAtivo(state, contato) {
      if (contato) {
        state.contatoAtivo = _.clone(contato);
      } else {
        state.contatoAtivo = null;
      }
    },
    novoContato(state) {
      state.contatoAtivo = _.clone(contatoModelo);
    },
    novoEmail(state) {
      state.emailAtivo = _.clone(emailModelo);
    },
    editarEmail(state, email) {
      state.emailAtivo = _.clone(email);
    },
    limparEmailAtivo(state) {
      state.emailAtivo = null;
    },
    novoTelefone(state) {
      state.telefoneAtivo = _.clone(telefoneModelo);
    },
    editarTelefone(state, telefone) {
      state.telefoneAtivo = _.clone(telefone);
    },
    limparTelefoneAtivo(state) {
      state.telefoneAtivo = null;
    },
  },
  actions: {
    async listar(context, { tipo_entidade, id_entidade }) {
      try {
        const response = await securedAxios.get(
          `/${tipo_entidade}/${id_entidade}/contatos`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    gravarContatos(context, { tipo_entidade, id_entidade, contatos }) {
      const promises = contatos.map((c) => {
        return new Promise((resolve, reject) => {
          const contato = ajustaContato(c);
          let p;
          if (contato.remover) {
            p = securedAxios.delete(
              `/${tipo_entidade}/${id_entidade}/contatos/${contato.id}`
            );
          } else if (contato.novo) {
            p = securedAxios.post(
              `/${tipo_entidade}/${id_entidade}/contatos`,
              contato
            );
          } else if (contato.editar) {
            p = securedAxios.put(
              `/${tipo_entidade}/${id_entidade}/contatos/${contato.id}`,
              contato
            );
          } else {
            return resolve(contato);
          }

          p.then(
            (response) => resolve(response.data),
            (err) => reject(err)
          );
        });
      });

      return Promise.all(promises);
    },
  },
};
